import { message, Spin } from 'antd';
import { useState } from 'react';
import { useAsync } from 'react-async-hook';
import { providerService } from 'services';
import { Licenses } from './FacilityCredentials/Licenses';
import { QRIS } from './FacilityCredentials/QRIS';
import { SchoolCredentials } from './FacilityCredentials/SchoolCredentials';
import { SchoolLetter } from './FacilityCredentials/SchoolLetter';
import { TYPES_OF_CARE } from 'constants';

const FacilityCredentials = ({ application, isEditable = false }) => {
  const [careFacility, setCareFacility] = useState(null);
  useAsync(async () => {
    if (application?.careFacility?.id !== undefined) {
      try {
        const _careFacility = await providerService.getCenterById(Number(application?.careFacility?.id));
        setCareFacility(_careFacility);
      } catch (error) {
        console.log('Error fetching care facility', error);
        message.error('Unable to get care facility information', 5);
      }
    }
  }, [application]);

  const isSchoolBased = careFacility?.type?.id === TYPES_OF_CARE.SCHOOL;

  return (
    <Spin spinning={careFacility === null}>
      {careFacility && (
        <>
          {isSchoolBased && (
            <>
              <SchoolCredentials careFacility={careFacility} isEditable={isEditable} />

              <div className="mt-8">
                <SchoolLetter careFacility={careFacility} isEditable={isEditable} />
              </div>
            </>
          )}

          <div className={isSchoolBased ? 'mt-8' : ''}>
            <Licenses careFacility={careFacility} application={application} isEditable={isEditable} />
          </div>

          <div className="mt-8">
            <QRIS
              careFacility={careFacility}
              application={application}
              state={careFacility?.address?.state}
              isEditable={isEditable}
            />
          </div>
        </>
      )}
    </Spin>
  );
};

export { FacilityCredentials };
